import { createGlobalStyle, keyframes } from 'styled-components';
import { defaultTheme } from '../config';


const rotate = keyframes`
from {
  transform: rotate(0deg) ;
}
to{
  transform: rotate(360deg) ;
}
`

export default createGlobalStyle`

@font-face {
    font-family: Montserrat;
    src: url("/assets/fonts/Montserrat-Regular.ttf") format("truetype");
}


@font-face {
    font-family: MontserratBold;
    src: url("/assets/fonts/Montserrat-Bold.ttf") format("truetype");
}


*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  outline: 0
}

html{
  width: 100%;
  min-height: 100vh !important;


}

.botao.icone  {
   
   display: flex;

   align-items: center;
   
   justify-content: center;
   gap: 10px;
}


.botao  {

   display: flex;

   align-items: center;

   justify-content: center;
   width: auto;
   height: 48px;
   padding: 0 20px;
   line-height: 1;
  
   transition: all 0.3s;
   font-size: 14px;
   color: #2C3E4E;
   border: 1px solid #2C3E4E;
   border-radius: 5px;
   background-color: transparent;
   text-decoration: none !important;
   cursor: pointer;

   &:hover{
    // border-color: #00A396;
   }
}



.botao.ativo, .botao.ativo2{
  
   background-color: #00A396;
   border: 0px;
   color: #fff;
   font-weight: bold;
}


.botao.ativo2{
 background:#fff ;

 background:#2C3E4E ;
   color:#fff ; 
 &:hover{
    
 }
}
button.nextAvaliation{
    background: #41517E;
    color: #fff;
    padding: 15px;
    font-size: 12px;
    margin: 10px auto;
    border: 0px;
    border-radius: 10px;
}

button.nextAvaliationReturn{
    background: #777;
    color: #fff;
    padding: 15px;
    font-size: 12px;
    margin: 10px auto;
    border: 0px;
    border-radius: 10px;
}



body {
//background: url('/assets/Fundo.jpg') no-repeat center;
background: #41517E;
background-size: cover ;
background-attachment: fixed;



.row-centered{
  width: 100%;
  display: flex ;
  justify-content: center;
  align-items: center;
}

.gap{
  gap: 15px;
}

.pad-sm{
  padding: 10px 15px !important;
}

.pad{
  padding: 15px !important;
}


.row-start{
  width: 100%;
display: flex ;
justify-content: flex-start;
align-items: center;
flex-direction: row;

@media (max-width: 750px) {
  flex-direction: column;
  }

} 

.row-to-column{
  width: 100%;
display: flex ;
justify-content: center;
align-items: center;
flex-direction: row;

@media (max-width: 750px) {
  flex-direction: column;
  }

} 

.row-to-column-reverse{
  width: 100%;
display: flex ;
justify-content: center;
align-items: center;
flex-direction: row;

@media (max-width: 750px) {
  flex-direction: column-reverse;
  }

} 

.row-to-column-start{
  width: 100%;
display: flex ;
justify-content: center;
align-items: center;
flex-direction: row;

@media (max-width: 750px) {
  flex-direction: column;
  justify-content: flex-start;
  }
} 
.gap-sm{
gap: 15px;
} 

.scaleOnHover{

transition: 0.5s all;

&:hover{
  transform: scale(1.05) ;
}

}


.row{
    display: flex ;
    flex-direction: row;
    align-items:center;
    justify-content: center;
  }

  .row-start{
    display: flex ;
    flex-direction: row;
    justify-content: flex-start;
  }

  .gap-sm{
    gap: 15px;
  }

  .gap-xs{
    gap: 7.5px;
  }

  .full-width{
    width: 100%;
  }

.column {
  display: flex ;
  flex-direction: column;
  align-items: center;

}
.column-start {
  display: flex ;
  flex-direction: column;
  align-items: flex-start;

}
.text-center{
  text-align: center;
  p,span,h2,h3 {
    text-align: center;
  }
}


>iframe {
  position: relative !important;
}


.filterButton{
  padding: 5px;
  background: #eee;
  color: #333;
  border-radius: 5px;
  border: 0px;
}

.filterActive{
 
  background: orange;
  color: #fff;
 
}

.videoGroupCoord{
  width: 100% ;
  max-width: 500px;
  background: #fff ;
  border-radius: 15px;
  box-shadow: 2px 2px 5px rgba(0,0,0,0.3);
  padding: 15px ;
  display: flex ;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 15px;


  >p{
    color: #333;
    font-size: 14px;
  }
}

   tr.highlight{
      background: rgb(12, 148, 144);
      color: #fff;
      th{
        color: #fff !important;
        text-align: left; 
      }
    }

.tableRef{
  width: 100%;
  max-width: 800px;
  background: #fff ;
    border: 2px solid #ccc !important;
    margin: 10px auto  !important;
    border-collapse: collapse  !important;

    tr.highlight{
      background: rgb(12, 148, 144);
      color: #fff;
      th{
        color: #fff !important;
        text-align: left; 
      }
    }
    td,th {
      border: 1px solid #ddd  !important;
      padding: 10px;
      color: #333  !important;
    }
  }

.react-datepicker{
  display: flex ;
}

.historyIcon {
  padding: 10px !important;
  background: #fff !important;
  width: 40px !important;
  height: 40px !important;
  border-radius: 50% !important;
  display: flex  !important;
  align-items: center !important;
  justify-content: center !important;
  cursor: pointer;
  svg{
    font-size: 24px !important;
    min-width: 24px;
    color: rgb(0,100,150) !important;
  }

  transition: 0.5s all;

  &:hover{
    transform: scale(1.05) ;
  }
}

.slick-track, .slick-slider, .slick-list, #sliderList{
  width: 100%;
}

.slick-slider, .slick-list, #sliderList{
  margin: 0px;
  padding: 0px;

  img{
    width: 100%;
  }


}

.slick-dots{
  bottom: 10px;

  button{
    height: 30px;
    width: 30px;
    &:before{
      height: 30px;
    width: 30px;
    font-size: 10px;
    }
    
  }
}

 
  background-position:  top;
  
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;



  color: #fff;
  -webkit-font-smoothing: antialiased;
  padding: 0;
  margin: 0 !important;
  min-height: 100vh !important;
  min-height: 100% !important;
  position: relative;



}



.shadow{
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}

.padding{
  padding: 15px;
}

.margin{
  margin: 15px;
}

.shadowBox{
  display: flex;
    background: rgb(255, 255, 255) !important;
    box-shadow: rgb(7 13 28 / 25%) 0px 10px 100px;
    margin: 20px 0px;
    border-radius: 10px;
    padding: 20px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

#root{
  min-height: 100vh;
 


}

body, input, button{
  font-family: Helvetica,  sans-serif;
  font-size: 16px;
}

h1,h2,h3,h4,h5,h6, strong{
font-weight: bold;
font-family:  'MontserratBold',Helvetica,  sans-serif;

}

h2{

      font-size: 16px;
}

p, span{
  font-family:'Montserrat',Helvetica,  sans-serif;
}

button{
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  >svg {
    margin: 0 5px;
  }
}

.wave {

  width: 200%;
  margin-left: -20%;
  z-index:0;

  @media (max-width: 1250px) {
    width: 400%;
    margin-left: -50%;
  }

  @media (max-width: 750px) {
    width: 800%;
    margin-left: -50%;
  }



}


.computerOnly{
display: flex !important;
@media (max-width: 1200px) {
    display: none !important;
  }
}

.mobileOnly{
display: none !important;
@media (max-width: 1200px) {
    display: flex !important;
  }
}

.fixedBottom{
    z-index: 0;
    position: fixed;
    bottom: -30px;
    right: 0px;
    width: 45%;
}
 

 .defaultButton {
         margin-top: 10px;
  
      
      padding: 20px;
      text-align: center;
    background: #1b73ba !important;
      border: 0px solid rgb(0, 15, 64);
      color: #fff  !important;
font-weight: bold;
      display: flex;
      justify-content: center;
      text-align: center;

      transition:  0.5s all;

      border-radius: 10px;
      box-shadow: 0px 5px 15px rgba(255,255,255,0.3);

          width: auto;
          max-width: 300px;
    min-height: 48px;
    padding: 5px 20px;
    line-height: 1;

      &:hover {
 
        background: #0A1F44 !important;
        color: #fff !important;
      }
    }

    button.defaultButtonGreen {
         margin-top: 10px;
      width: 200px;
      min-width: 200px;
     
      padding: 20px;
      text-align: center;
      background: #0faaa0 !important;
      border: 0px solid rgb(0, 15, 64);
      color: #fff  !important;
font-weight: bold;
      display: flex;
      justify-content: center;
      text-align: center;

      transition:  0.5s all;

      border-radius: 10px;
      box-shadow: 0px 5px 15px rgba(255,255,255,0.3);
      &:hover {
        transform: translateY(-5px);
        box-shadow: 0px 5px 5px rgba(171, 230, 255,0.7);
        
      }
    }

button.defaultButtonRed {
         margin-top: 10px;
      width: 200px;
      min-width: 200px;
      padding: 20px;
      text-align: center;
      background: red !important;
      color: #fff  !important;

      display: flex;
      justify-content: center;
      text-align: center;

      transition:  0.5s all;
      border: 0;
      border-radius: 10px;

      &:hover {
        transform: translateY(-10px);
        box-shadow: 0px 5px 5px rgba(255,255,255,0.3);
      }
    }

    .defaultButtonReverse {
         margin-top: 10px;
      width: 200px;
      min-width: 200px;
      padding: 20px;
      text-align: center;
      flex-direction: column;
      display: flex ;
      justify-content: center;
      align-items: center;
 
      color: rgb(0, 15, 64)  !important;
      font-weight: bold;

      background: rgb(171, 230, 255) !important;

      display: flex;
      justify-content: center;
      text-align: center;

      transition:  0.5s all;
      border: 0;
      border-radius: 10px;
    
      &:hover {
        transform: translateY(-10px);
        box-shadow: 0px 5px 5px rgba(255,255,255,0.3);
      }
    }

    .tip{
      padding: 5px;
     font-size: 14px;
      width:100%;
      text-align: left;
      font-weight: bold;
   
      color: #916f00 !important;
      display: flex ;
      justify-content: flex-start;
      align-items: center;

      >svg {
        animation: ${rotate} 5s infinite ;
      }
     
  
    }

    .rotateAnimation{
      animation: ${rotate} 5s infinite ;
    }

    .simpleButton {
         margin-top: 0px;
 
  
      padding: 5px;
      text-align: center;
      background: #fff !important;
      color: #333  !important;
      font-weight: bold;

      display: flex;
      justify-content: center;
      text-align: center;

      >a{
        color: #333  !important;
        font-weight: bold;

      }

      transition:  0.5s all;
      border: 0;
      border-radius: 10px;

      &:hover {
        transform: scale(1.1);
        box-shadow: 0px 5px 5px rgba(255,255,255,0.3);
      }
    }


    .defaultButtonReverseMini {
         margin-top: 0px;
      width: 100%;
      max-width: 200px;
      padding: 5px 10px;
      text-align: center;
      background: #f16621 !important;
      color: #fff  !important;
      font-weight: bold;

      display: flex;
      justify-content: center;
      text-align: center;

      >a{
        color: #fff  !important;
        font-weight: bold;

      }

      transition:  0.5s all;
      border: 0;
      border-radius: 10px;

      &:hover {
        transform: translateY(-10px);
        box-shadow: 0px 5px 5px rgba(255,255,255,0.3);
      }
    }

    .simpleButton{

      margin-top: 0px !important;
         padding: 5px !important;

         text-align: center !important;
      justify-content: center !important;
      display: flex  !important;
      align-items: center;
      padding: 10px !important;
      background: #ccc !important;
      color: #333 !important;
      transition: 0.5s all ;
      border: 1px solid #333;
      &:hover{
        background: #333 ;
        color: #fff;
      }
    }

    .simpleButtonActive{

margin-top: 0px !important;
   padding: 5px !important;

   text-align: center !important;
justify-content: center !important;
display: flex  !important;
align-items: center;
padding: 10px !important;
transition: 0.5s all ;
 
background: #333  !important;
  color: #fff  !important;
 
}

.simpleButton{

margin-top: 0px !important;
   padding: 5px !important;

   text-align: center !important;
justify-content: center !important;
display: flex  !important;
align-items: center;
padding: 10px !important;
transition: 0.5s all ;
border: 1px solid #333 !important;
background: #fff !important;
  color: #333   !important;
 
}

    button.defaultButtonMini, button.defaultButtonMiniSelect,    button.defaultButtonMini2, button.buttonBlue {
         margin-top: 0px !important;
         padding: 5px !important;
      width:auto !important;
      min-width:auto !important;

      text-align: center !important;
      justify-content: center !important;
      background: rgb(0,15,64) !important ;
      color: #fff  ;

      display: flex  !important;
      justify-content: center !important;


      transition: background 0.5s;
      border: 0;
      border-radius: 10px;

      &:hover {
        background: ${defaultTheme.defaultBackground}  !important;
      }
    }

    button.defaultButtonMiniSelect{
      width: 100% !important;
      padding: 10px !important;
      text-align: left !important;
      justify-content: flex-start !important;
      text-transform: uppercase;
    }


    button.defaultButtonMini2{
      padding: 10px 20px  !important ;
      margin-top: 25px ;
    }

    button.buttonBlue{
      background: rgb(0,100,150) !important;

      &:hover {
        background: rgb(0,120,180) !important;
      }
    }


    .closeButton{
      padding: 10px;
      border: 0;
      opacity: 0.8;
      background: #555;
      color: #fff;
      transition: 0.5s all;

      margin: 5px;
      &:hover{
        opacity: 1;
      }
    }


    a {
      text-decoration: none !important;
    }


    .lineIcon {
      margin:5px;
      background: #fff;
       border: 1px solid #333;
       border-radius: 50%;
       height: 35px;
       width: 35px;
       padding: 5px;
       
       >svg{
         width: 25px !important;
         font-size: 25px;

       }
       display: flex;
       align-items: center;
       justify-content: center;
    }

    .videoContainer{
      width: 100%;
      position: relative;
      height: auto;
   
    }

form {
    >div{
  
  background: #fff !important;
  color: #333  !important;
 

  span{
    color: #333  !important;
  }

  input {
    color: #333  !important;

    &::placeholder {
    color: #333  !important;
  }
  }
}
}
`;
